/* عالم سمسم – مقارنة العطور: زرار المقارنة + شريط المقارنة العائم + «قارن مع المشابه» + تتبع الاستخدام */
(function () {
  if (window.SMSMCMP) return;
  var KEY = 'smsm-compare', MAX = 4;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = ROOT + 'pages/compare-perfumes';
  var ON_PAGE = /\/pages\/compare-perfumes/.test(location.pathname);
  var SELF = (document.currentScript && document.currentScript.src) || '';
  var T = EN ? {
    add: 'Add to compare', added: 'In compare – tap to remove', toastAdd: 'Added to compare', toastRm: 'Removed from compare',
    full: 'You can compare up to 4 perfumes', cmp: 'Compare now', clear: 'Clear', need: 'Add one more perfume to compare', slots: 'Compare perfumes',
    pick1: 'Add one more perfume to compare', toastGo: 'Compare now', simBtn: 'Compare this perfume with its closest matches', simSub: 'See the difference in notes, strength and price per ml side by side'
  } : {
    add: 'أضف للمقارنة', added: 'في المقارنة – اضغط للإزالة', toastAdd: 'اتضاف للمقارنة', toastRm: 'اتشال من المقارنة',
    full: 'تقدر تقارن لحد 4 عطور بس', cmp: 'قارن دلوقتي', clear: 'مسح', need: 'ضيف عطر كمان عشان تقارن', slots: 'مقارنة العطور',
    pick1: 'ضيف عطر كمان عشان تقارن', toastGo: 'قارن دلوقتي', simBtn: 'قارن العطر ده بأقرب العطور ليه', simSub: 'شوف الفرق في المكونات والقوة وسعر المل جنب بعض'
  };

  /* تتبع: بيبعت الحدث لـ Shopify (Customer events) و dataLayer و gtag/fbq لو موجودين */
  function trk(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { var o = { event: name }; for (var k in data) o[k] = data[k]; (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data); } catch (e) {}
  }
  window.smsmTrack = trk;

  function load() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }).slice(0, MAX) : []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} render(); sync(); try { window.dispatchEvent(new CustomEvent('smsm:compare', { detail: a })); } catch (e) {} }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function short(t) { var s = String(t || '').split(/\s[–\-|]\s|\|/)[0].replace(/^(عطر|مجموعة|معطر|دهن)\s+/, '').trim(); return s.length > 26 ? s.slice(0, 24) + '…' : s; }

  function handleFrom(btn) {
    var card = btn.closest('.product-item, .product-card, [data-product-handle]');
    if (card) {
      if (card.dataset && card.dataset.productHandle) return card.dataset.productHandle;
      var a = card.querySelector('a[href*="/products/"]');
      if (a) { var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (m) return decodeURIComponent(m[1]); }
    }
    var m2 = location.pathname.match(/\/products\/([^/?#]+)/);
    return m2 ? decodeURIComponent(m2[1]) : null;
  }
  function getInfo(h) {
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return { h: h, t: h, i: '' };
      var img = p.featured_image || ''; if (img.indexOf('//') === 0) img = 'https:' + img;
      return { h: h, t: p.title, i: img };
    }).catch(function () { return { h: h, t: h, i: '' }; });
  }
  function toggle(h, src) {
    var a = load(), i = -1;
    a.forEach(function (x, k) { if (x.h === h) i = k; });
    if (i > -1) { a.splice(i, 1); save(a); toast(T.toastRm); trk('smsm_compare_remove', { handle: h, count: a.length }); return; }
    if (a.length >= MAX) { toast(T.full); openBar(); return; }
    a.push({ h: h, t: '', i: '' }); save(a);
    toast(T.toastAdd + (a.length < 2 ? ' — ' + T.pick1 : ''), a.length >= 2);
    openBar();
    trk('smsm_compare_add', { handle: h, count: a.length, source: src || (location.pathname.indexOf('/products/') > -1 ? 'product' : 'card') });
    getInfo(h).then(function (info) { var b = load(); b.forEach(function (x) { if (x.h === h) { x.t = info.t; x.i = info.i; } }); try { localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {} render(); });
  }

  /* شكل الزرار حسب الحالة */
  function sync() {
    document.querySelectorAll('button-compare, .product-item__button-compare').forEach(function (b) {
      var h = b.dataset.smsmHandle || handleFrom(b); if (!h) return; b.dataset.smsmHandle = h;
      var on = has(h);
      b.classList.toggle('smsm-cmp-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.added : T.add);
      var tip = b.querySelector('.tooltip-content'), tx = on ? T.added : T.add; if (tip && tip.textContent !== tx) tip.textContent = tx;
    });
  }

  /* الشريط العائم */
  var bar, tq;
  function css() {
    if (document.getElementById('smsm-cmp-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-cmp-css';
    s.textContent = '' +
      'button-compare.smsm-cmp-on,.product-item__button-compare.smsm-cmp-on{background:#512E83!important;border-color:#512E83!important;color:#fff!important}' +
      'button-compare.smsm-cmp-on svg,.product-item__button-compare.smsm-cmp-on svg{color:#fff;stroke:#fff}' +
      '.smsm-cmpbar{position:fixed;inset-inline:12px;bottom:calc(76px + env(safe-area-inset-bottom));z-index:60;max-width:760px;margin:0 auto;background:#fff;border:1px solid #E6DDF1;border-radius:18px;box-shadow:0 12px 34px rgba(58,31,97,.18);padding:10px 12px;display:flex;flex-wrap:wrap;align-items:center;gap:8px 10px;font-family:var(--body-font,inherit);transform:translateY(140%);opacity:0;transition:transform .35s cubic-bezier(.3,1,.3,1),opacity .25s;pointer-events:none}' +
      '.smsm-cmpbar.is-on{transform:none;opacity:1;pointer-events:auto}' +
      '.smsm-cmpbar__info{flex:1 1 140px;min-width:0;line-height:1.35}' +
      '.smsm-cmpbar__ttl{display:block;font-size:12.5px;font-weight:800;color:#3A1F61;white-space:nowrap}' +
      '.smsm-cmpbar__ttl b{color:#A8822A}' +
      '.smsm-cmpbar__nm{display:block;font-size:11.5px;font-weight:600;color:#6B6280;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.smsm-cmpbar__slots{display:flex;gap:6px;flex:0 0 auto}' +
      '.smsm-cmpbar__s{position:relative;width:46px;height:46px;flex:0 0 46px;border-radius:12px;border:1px dashed #D9CDE8;background:#FBF8FD;display:flex;align-items:center;justify-content:center;color:#B9AECB;font-size:18px}' +
      '.smsm-cmpbar__s img{width:100%;height:100%;object-fit:contain;border-radius:11px;background:#fff}' +
      '.smsm-cmpbar__s.full{border-style:solid;border-color:#E6DDF1}' +
      '.smsm-cmpbar__x{position:absolute;top:-6px;inset-inline-end:-6px;width:18px;height:18px;border-radius:50%;background:#3A1F61;color:#fff;border:0;font-size:11px;line-height:18px;padding:0;cursor:pointer}' +
      '.smsm-cmpbar__go{border:0;border-radius:999px;background:#512E83;color:#fff;font-weight:800;font-size:13.5px;padding:11px 18px;cursor:pointer;white-space:nowrap;text-decoration:none}' +
      '.smsm-cmpbar__go[aria-disabled=true]{background:#CFC4DE;cursor:default}' +
      '.smsm-cmpbar__clr{border:0;background:none;color:#8C82A3;font-size:12px;font-weight:700;cursor:pointer;padding:4px}' +
      '.smsm-cmptoast{position:fixed;left:50%;bottom:calc(150px + env(safe-area-inset-bottom));transform:translate(-50%,10px);background:#1E1530;color:#fff;font-size:13px;font-weight:700;padding:9px 16px;border-radius:999px;z-index:61;opacity:0;transition:all .25s;pointer-events:none;font-family:var(--body-font,inherit);max-width:calc(100vw - 32px);text-align:center}' +
      '.smsm-cmptoast.is-on{opacity:1;transform:translate(-50%,0)}' +
      '.smsm-cmptoast a{color:#F3DC86;text-decoration:underline;margin-inline-start:8px;pointer-events:auto}' +
      '@media(min-width:990px){.smsm-cmpbar{bottom:20px;flex-wrap:nowrap}.smsm-cmptoast{bottom:110px}.smsm-cmpbar__s{width:54px;height:54px;flex-basis:54px}}' +
      '@media(max-width:989px){.smsm-cmpbar__info{flex-basis:100%;order:-1;display:flex;align-items:baseline;gap:8px}.smsm-cmpbar__nm{flex:1;min-width:0}.smsm-cmpbar__slots{flex:1 1 auto}}' +
      '@media(max-width:420px){.smsm-cmpbar__s{width:38px;height:38px;flex-basis:38px}.smsm-cmpbar__go{padding:10px 14px;font-size:13px}}' +
      '@media(max-width:1024.98px){.product-item button-compare.hidden,.product-item .product-item__button-compare.hidden{display:inline-flex!important}.product-item__button-action .product-item__button{width:38px!important;height:38px!important}.product-item__button-action .product-item__button svg{width:15px;height:15px}.product-item__button-action .tooltip-content{display:none!important}}' +
      '.smsm-sim__cmp{display:flex;flex-direction:column;align-items:center;gap:6px;margin:18px auto 0;text-align:center}' +
      '.smsm-sim__cmpbtn{display:inline-flex;align-items:center;gap:8px;border-radius:999px;background:#512E83;color:#fff!important;font-weight:800;font-size:14.5px;padding:12px 22px;text-decoration:none;box-shadow:0 8px 20px -10px rgba(81,46,131,.8)}' +
      '.smsm-sim__cmpbtn i{font-style:normal;color:#F3DC86}' +
      '.smsm-sim__cmp small{font-size:12.5px;color:#6B6280}';
    document.head.appendChild(s);
  }
  function render() {
    if (ON_PAGE) return;
    var a = load();
    if (!bar) {
      if (!a.length) return;
      css(); bar = document.createElement('div'); bar.className = 'smsm-cmpbar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', T.slots); bar.dir = EN ? 'ltr' : 'rtl';
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var x = e.target.closest('[data-rm]'); if (x) { e.preventDefault(); var b = load().filter(function (y) { return y.h !== x.dataset.rm; }); save(b); trk('smsm_compare_remove', { handle: x.dataset.rm, count: b.length }); return; }
        if (e.target.closest('[data-clr]')) { e.preventDefault(); save([]); trk('smsm_compare_clear', {}); return; }
        var g = e.target.closest('.smsm-cmpbar__go');
        if (g) { if (load().length < 2) { e.preventDefault(); toast(T.need); } else trk('smsm_compare_open', { count: load().length, source: 'bar' }); }
      });
    }
    var slots = '';
    for (var k = 0; k < MAX; k++) {
      var x = a[k];
      slots += x ? '<span class="smsm-cmpbar__s full" title="' + esc(x.t) + '">' + (x.i ? '<img src="' + esc(x.i) + (x.i.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="' + esc(x.t) + '">' : '') + '<button type="button" class="smsm-cmpbar__x" data-rm="' + esc(x.h) + '" aria-label="remove">×</button></span>' : '<span class="smsm-cmpbar__s">+</span>';
    }
    var names = a.map(function (x) { return short(x.t); }).filter(Boolean).join(' · ');
    bar.innerHTML = '<span class="smsm-cmpbar__info"><span class="smsm-cmpbar__ttl">' + T.slots + ' <b>' + a.length + '/' + MAX + '</b></span><span class="smsm-cmpbar__nm">' + esc(names || (a.length < 2 ? T.pick1 : '')) + '</span></span>' +
      '<span class="smsm-cmpbar__slots">' + slots + '</span>' +
      '<button type="button" class="smsm-cmpbar__clr" data-clr>' + T.clear + '</button>' +
      '<a class="smsm-cmpbar__go" href="' + PAGE + '"' + (a.length < 2 ? ' aria-disabled="true"' : '') + '>' + T.cmp + (a.length ? ' (' + a.length + ')' : '') + '</a>';
    bar.classList.toggle('is-on', a.length > 0);
  }
  function openBar() { render(); }
  var tt;
  function toast(msg, go) {
    css(); var t = document.querySelector('.smsm-cmptoast');
    if (!t) { t = document.createElement('div'); t.className = 'smsm-cmptoast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.classList.remove('smsm-wltoast');
    t.innerHTML = esc(msg) + (go && !ON_PAGE ? '<a href="' + PAGE + '" data-smsm-cmpgo>' + T.toastGo + '</a>' : '');
    t.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('is-on'); }, go ? 2600 : 1800);
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-smsm-cmpgo]')) trk('smsm_compare_open', { count: load().length, source: 'toast' }); });

  /* نمسك ضغطة زرار المقارنة قبل الثيم */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button-compare, .product-item__button-compare');
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var h = b.dataset.smsmHandle || handleFrom(b); if (!h) return;
    b.dataset.smsmHandle = h; toggle(h);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('button-compare, .product-item__button-compare'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); var h = b.dataset.smsmHandle || handleFrom(b); if (h) { b.dataset.smsmHandle = h; toggle(h); }
  }, true);

  /* صفحة المنتج: زرار «قارن العطر ده بأقرب العطور ليه» تحت «عطور ريحتها قريبة» */
  function simCta() {
    document.querySelectorAll('.smsm-sim').forEach(function (sec) {
      if (sec.hidden || sec.querySelector('.smsm-sim__cmp')) return;
      var grid = sec.querySelector('.smsm-sim__grid'), me = sec.dataset.handle; if (!grid || !me) return;
      var hs = [];
      grid.querySelectorAll('a.smsm-sim__card[href*="/products/"]').forEach(function (a) { var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (m && hs.length < MAX - 1) hs.push(decodeURIComponent(m[1])); });
      if (!hs.length) return;
      css();
      var box = document.createElement('div'); box.className = 'smsm-sim__cmp';
      box.innerHTML = '<a class="smsm-sim__cmpbtn" href="' + PAGE + '?p=' + [me].concat(hs).map(encodeURIComponent).join(',') + '"><i>⚖</i>' + T.simBtn + '</a><small>' + T.simSub + '</small>';
      box.querySelector('a').addEventListener('click', function () { trk('smsm_compare_open', { count: hs.length + 1, source: 'similar', handle: me }); try { localStorage.setItem(KEY, '[]'); } catch (e) {} });
      grid.parentNode.appendChild(box);
    });
  }

  /* المفضلة: عداد الهيدر + رسالة تأكيد */
  var WLKEY = 'glozin__wishlist-items';
  function wlList() { try { var a = JSON.parse(localStorage.getItem(WLKEY) || '[]'); return Array.isArray(a) ? a.filter(Boolean) : []; } catch (e) { return []; } }
  function wlBadge() {
    var n = wlList().length;
    document.querySelectorAll('[data-smsm-wishlist-badge], [data-smsm-wishlist-count], .smsm-wishlist-count, .header__wishlist .wishlist-count').forEach(function (el) {
      if (el.textContent.trim() !== String(n)) el.textContent = n;
      el.setAttribute('aria-label', n + (EN ? ' wishlist items' : ' في المفضلة'));
      el.classList.toggle('is-empty', n === 0);
    });
  }
  var wlT;
  function wlToast(added) {
    css(); var t = document.querySelector('.smsm-cmptoast');
    if (!t) { t = document.createElement('div'); t.className = 'smsm-cmptoast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.classList.add('smsm-wltoast');
    t.innerHTML = (added ? (EN ? 'Added to wishlist' : 'اتضاف للمفضلة') : (EN ? 'Removed from wishlist' : 'اتشال من المفضلة')) +
      (added ? '<a href="' + ROOT + 'pages/wishlist">' + (EN ? 'View' : 'عرض المفضلة') + '</a>' : '');
    t.classList.add('is-on'); clearTimeout(tt); clearTimeout(wlT);
    wlT = setTimeout(function () { t.classList.remove('is-on'); t.classList.remove('smsm-wltoast'); }, 2200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button-wishlist, .product-item__button-wishlist');
    if (!b) return;
    var id = b.dataset.productId, before = id ? wlList().indexOf(id) > -1 : null;
    setTimeout(function () {
      wlBadge();
      if (id == null) return;
      var after = wlList().indexOf(id) > -1;
      if (after !== before) {
        wlToast(after);
        document.querySelectorAll('button-wishlist[data-product-id="' + id + '"]').forEach(function (x) { x.classList.toggle('active', after); });
      }
    }, 120);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === WLKEY) wlBadge(); });
  window.addEventListener('pageshow', wlBadge);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { render(); sync(); } });

  /* صفحة المقارنة: تحميل الإضافات (أضف الكل للسلة، العروض، البحث، الهيدر الثابت) */
  function loadPlus() {
    if (!ON_PAGE || window.SMSMCMPPLUS) return;
    var src = SELF;
    if (!src) { var sc = document.querySelector('script[src*="smsm-compare.js"]'); src = sc ? sc.src : ''; }
    if (!src) return;
    var s = document.createElement('script'); s.src = src.replace('smsm-compare.js', 'smsm-compare-plus.js'); s.defer = true; document.head.appendChild(s);
  }

  function boot() { css(); sync(); render(); wlBadge(); simCta(); loadPlus(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if ('MutationObserver' in window) { var mo = new MutationObserver(function () { clearTimeout(tq); tq = setTimeout(function () { sync(); wlBadge(); simCta(); }, 250); }); var obs = function () { mo.observe(document.body, { childList: true, subtree: true }); }; if (document.body) obs(); else document.addEventListener('DOMContentLoaded', obs); }
  window.SMSMCMP = { load: load, save: save, toggle: toggle, KEY: KEY, MAX: MAX, track: trk };
})();
